import context from '../context';

export default function canActOnLocation(user, location) {
  if (!location) {
    return false;
  }

  const _user = user.isAuthenticationDotUser ? context.personasDict[user.id] : user;
  return Boolean(
    _user.isAdmin || (_user.isManager && _user.locationIds.find((id) => location.id === id))
  );
}
